import "vuetify/styles";
import { createVuetify } from "vuetify";
import "@mdi/font/css/materialdesignicons.css";
import { de, en } from "vuetify/locale";

// Components and directives are auto-imported on demand by vite-plugin-vuetify
// (autoImport, see vite.config.mjs), so only the ones actually used are bundled
// instead of registering the whole library globally.

const customTheme = {
    dark: false,
    colors: {
        primaryBrown: "#BD934F",
        primaryBlueDark: "#1C364B",
        primaryCream: "#F7F6F2",
        primaryDarkColor: "#232323",
        primaryGreyLight: "#C3C9CE",
        primaryRed: "#D33232",
        primaryYellow: "#D9C08D",
        primaryGreen: "#15A265",
        bgPrimaryBlack: "#222222",
        bgPrimaryBlueDark: "#00182C",
        bgPrimaryBlue: "#172B3C",
    },
};

const vuetify = createVuetify({
    theme: {
        defaultTheme: "customTheme",
        themes: { customTheme },
    },
    icons: {
        defaultSet: "mdi",
    },
    locale: {
        locale: document.documentElement.lang || "de",
        fallback: "en",
        messages: { de, en },
    },
});

export default vuetify;
